import DailyMealLogger from '../meals/DailyMealLogger'
import type { CycleProfile } from '../../lib/cycle'
import type { GroceryItem, MealBlock } from '../../lib/protocolTypes'

type MealsTabProps = {
  userId: string | null
  meals: MealBlock[]
  grocery: GroceryItem[]
  cycleProfile?: CycleProfile | null
  onBatchGroceryChange?: (items: GroceryItem[]) => void
}

const MealsTab = (props: MealsTabProps) => <DailyMealLogger {...props} />

export default MealsTab
